<div class="absolute inset-0 flex flex-col items-stretch justify-start w-screen h-screen max-w-lg p-12 pt-36">
	<ng-content></ng-content>
</div>
